export const GUEST = 'guest'
export const USER = 'user'
export const ADMIN = 'admin'